<template>
    <header>
        <div class="klwk-nav" style="background: rgb(255, 255, 255); position: fixed;">
            <div class="container">
                <section class="left">
                    <div class="nav-list">
                        <div class="logo">
                            <a href="/" style=""><img src="https://cdn.kuailework.com/images/officialWebsite/index/head_img_logo.png" alt=""></a>
                        </div>
                        <div class="nav-btn nav-open-app arrow" id="index">
                            <!-- 根据域名判断首页链接 -->
                            <a :href="baseDomain" style="font-weight: bold;">首页</a>
                            <label></label>
                        </div>

                        <!--  -->
                        <div class="nav-btn nav-open-app arrow" id="talent">
                            <a style="">产品与服务 <span class="arrowHover"></span></a>
                            <label></label>
                            <div class="nav-open-tab _open-app">
                                <div class="open-app-box">
                                    <div class="sub_nav">
                                        <ul class="subtit" id="sub_pro">
                                            <li>
                                                <!-- 根据域名判断人才配置服务链接 -->
                                                <a :href="baseDomain + 'talentAllocation'" style="">人才配置服务
                                                </a>
                                            </li>
                                            <li>
                                                <!-- 根据域名判断人力外包服务链接 -->
                                                <a :href="baseDomain + 'talent'" style="">人力外包服务</a>
                                            </li>
                                            <li>
                                                <!-- 根据域名判断人才培训与发展链接 -->
                                                <a :href="baseDomain + 'development'" style="">人才培训与发展</a>
                                            </li>
                                            <li>
                                                <!-- 根据域名判断人才培训与发展链接 -->
                                                <a :href="baseDomain + 'consult'" style="">企业管理咨询</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--  -->
                        <div class="nav-btn nav-open-app arrow" id="integration">
                            <!-- 根据域名判断数字化平台链接 -->
                            <a :href="baseDomain + 'integration?typename=yth'" style="">数字化平台</a>
                            <label></label>
                        </div>
                        <div class="nav-btn nav-open-app arrow" id="programme">
                            <!-- 根据域名判断行业解决方案链接 -->
                            <a :href="baseDomain + 'industry'" style="">行业解决方案</a>
                            <label></label>
                        </div>
                        <div class="nav-btn nav-open-app arrow" id="news">
                            <a @click="menuLink('news-index')" :style="activeMenu == 'news-index'?'font-weight: bold;':''" style="">资讯中心</a>
                            <label :class="activeMenu == 'news-index'?'banner_header_hover':''"></label>
                        </div>
                        <div class="nav-btn nav-open-app arrow" id="klwk">
                            <a @click="menuLink('article-index')" href="javascript:void(0)" :style="activeMenu == 'article-index'?'font-weight: bold;':''">快乐直聘</a>
                            <label :class="activeMenu == 'article-index'?'banner_header_hover':''"></label>
                        </div>
                        <div class="nav-btn nav-open-app arrow" id="about">
                            <!-- 根据域名判断关于我们链接 -->
                            <a :href="baseDomain + 'about'" style="">关于我们</a>
                            <label></label>
                        </div>
                        <div class="nav-btn nav-open-app arrow" id="goods">
                            <!-- 根据域名判断招聘链接 -->
                            <a :href="baseDomain + 'recruit/index'" style="">招聘</a>
                            <label></label>
                        </div>
                    </div>
                </section>
                <section class="right">
                    <div style="display:flex;align-items:center;font-size: 14px;padding-right: 10px">
                        <a href="https://pc.kuailework.com/vs3/html/account/login.html" style="margin-right: 10px;">登录</a>
                        <a href="https://pc.kuailework.com/vs3/html/account/register.html" style="">注册</a>
                    </div>
                    <div class="phone">
                        <img src="https://cdn.kuailework.com/images/officialWebsite/index/icon_phone.png" alt="">
                        <div class="vz-font">400-607-6006</div>
                    </div>
                </section>
            </div>
        </div>
    </header>
</template>
<script>
    import getData from "@/api/getData";

    export default {
        name: 'myHeader',
        data() {
            return {

            }
        },
        created() {
        },
        props:{
            activeMenu: {
                default: '',
            }
        },
        methods: {
            menuLink(v){
                this.$router.push({
                    name: v
                })
            }
        },
        computed: {
            /**
             * 根据当前域名返回对应的基础域名
             * @returns {string} 基础域名
             */
            baseDomain() {
                const hostname = window.location.hostname;
                if (hostname.includes('soucaigroup')) {
                    return 'https://www.soucaigroup.com/';
                }
                // kuailework 域名或其他域名都使用默认域名
                return '/';
            }
        }
    }
</script>
<style scoped>
    *{
        padding: 0;
        margin: 0;
        text-align: left;
        -webkit-font-smoothing: antialiased;
        font-family: PingFangSC-Regular, PingFang SC;
    }
    .vz-font {
        font-weight: bold;
    }
    label.banner_header_hover {
        position: absolute;
        bottom: 0;
        left: 50%;
        z-index: 99;
        transform: translateX(-50%);
        width: 100%;
        height: 4px;
        background-color: #1478FF;
        border-radius: 2px 2px 0 0;
        transition: width 0.3s;
    }
    .open-app-box li {
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: center;
        margin-top: 10px;
    }
    .subtit li a {
        font-size: 16px;
        margin-top: 20px;
        text-align: center;
    }
    .subtit li a:hover {
        display: inline-block;
        width: 100%;
        color: #1478FF !important;
    }
    a{
        text-decoration: none;
    }
    .klwk-nav .logo img{
        width: 100%;
        height: 100%;
    }
    .logo {
        width: 101px;
        height: 36px;
        float: left;
        margin-top: 12px;
        border-radius: 8px;
    }
    /* 导航 */
    .product-page .banner {
        height: 480px;
        text-align: center;
    }
    .product-page .banner .logo {
        margin-top: 60px;
        width: 120px;
        height: 120px;
    }
    .product-page .banner .text {
        width: 45%;
        margin: 0 auto;
        line-height: 36px;
        color: #fff;
        font-size: 18px;
    }
    .product-page .banner .email {
        display: inline-block;
        margin: 68px auto 0;
    }
    .product-page .slogan {
        margin: 68px auto 0;
        width: 1115px;
        height: 222px;
        overflow: hidden;
        text-align: center;
        box-shadow: 0 3px 8px 0 rgba(9, 10, 11, 0.08);
        background-image: url(/static/common/moka_element.svg);
        background-repeat: no-repeat;
        background-position: 90% bottom;
        background-size: 122px;
    }
    .product-page .slogan .title {
        margin-top: 52px;
        font-size: 32px;
        font-weight: 700;
        color: #0e1421;
    }
    .product-page .slogan .text {
        width: 604px;
        margin: 20px auto 0;
        line-height: 24px;
        color: #758296;
    }
    .product-page .mage {
        width: 1115px;
        height: 430px;
        overflow: hidden;
        margin: auto;
        padding: 10px 0;
    }
    .product-page .mage:not(:last-child) {
        border-bottom: 1px solid #dfe2eb;
    }
    .product-page .mage .title {
        margin-bottom: 24px;
        font-size: 32px;
        font-weight: 700;
        color: #0e1421;
    }
    .product-page .mage .text {
        font-size: 14px;
        line-height: 32px;
        color: #758296;
    }
    .product-page .mage .mage-left {
        float: left;
        overflow: hidden;
        width: 557px;
    }
    .product-page .mage .image {
        width: 557px;
    }
    .product-page .bottom-container {
        position: relative;
        padding-top: 328px;
    }
    .product-page .user {
        position: absolute;
        top: 60px;
        left: calc(50% - 505px);
        width: 1010px;
        height: 328px;
        z-index: 1;
        text-align: center;
        margin: 0 auto;
        padding: 0 140px;
        background: #fff;
        background-image: url(/static/common/quote.svg);
        background-repeat: no-repeat;
        background-position: 60px 60px;
        box-shadow: 0 0 21px 0 rgba(14, 20, 33, 0.05);
        border: 1px solid #f2f6ff;
        border-radius: 8px;
    }
    .product-page .user .logo {
        width: 200px;
        margin-top: 42px;
    }
    .product-page .user .text {
        margin-top: 30px;
        line-height: 36px;
        font-size: 14px;
        color: #494d5a;
    }
    .product-page .bottom {
        height: 288px;
        position: relative;
        overflow: hidden;
        background-image: linear-gradient(0deg, #11ba1f, #12b661);
    }
    .product-page .bottom .body {
        margin: 120px auto 0;
        width: 1020px;
    }
    .product-page .bottom .title {
        font-size: 32px;
        color: #fff;
    }
    .product-page .bottom .email {
        float: right;
    }
    .product-page .bottom .image {
        position: absolute;
        bottom: 0;
        left: -90px;
        width: 452px;
        opacity: 0.06;
    }
    .button-container {
        position: relative;
        box-sizing: content-box;
        width: 147px;
        height: 40px;
        padding: 0 8px;
        font-size: 16px;
        line-height: 40px;
        letter-spacing: -0.08px;
        color: #fff;
        border: none;
        /* border: 1px solid #dfe2eb; */
        border-radius: 22px;
        background: transparent;
        font-family: inherit;
        overflow: hidden;
        outline: none;
        cursor: pointer;
        transition: border-color 0.3s ease;
    }
    .button-container .icon-container-bg {
        border-radius: 20px;
        /* background-color: #0fad2c; */
        background: rgba(0, 0, 0, 0.2);
        transition: all 0.4s ease;
    }
    .button-container .icon-container,
    .button-container .icon-container-bg {
        position: absolute;
        left: 4px;
        top: 50%;
        width: 32px;
        height: 32px;
        transform: translateY(-50%);
    }
    .button-container .icon-container {
        line-height: 22px;
        transition: transform 0.3s ease;
    }
    .button-container .icon-container .svg-icon {
        fill: #fff;
    }
    .button-container .icon-container .phone {
        position: absolute;
        left: calc(50% - 8px);
        top: calc(50% - 8px);
        transform-origin: 57% 45%;
    }
    .button-container .icon-container .signal-small {
        position: absolute;
        left: calc(50% + 1px);
        top: calc(50% - 17px);
        opacity: 0;
    }
    .button-container .icon-container .signal-small .signal-big {
        position: absolute;
        left: 0;
        top: -1px;
        opacity: 0;
    }
    .button-container .word {
        position: absolute;
        right: 9px;
        width: 142px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid #1478FF;
        top: 50%;
        transform: translateY(-51%);
        transition: transform 0.3s ease, color 0.3s ease;
    }
    .button-container:not(:hover) .icon-container .phone {
        animation: ring-1199d941 2.2s ease infinite;
    }
    .button-container:not(:hover) .icon-container .signal-small {
        animation: signal-small-1199d941 2.2s linear infinite;
    }
    .button-container:not(:hover) .icon-container .signal-small .signal-big {
        animation: signal-big-1199d941 2.2s linear infinite;
    }
    .button-container:not(.button-container-theme-white):hover {
        color: #fff;
    }
    .button-container:not(.button-container-theme-white):hover .icon-container-bg {
        left: -40px;
        width: calc(100% + 90px);
        height: calc(100% + 60px);
        border-radius: 60px;
    }
    .button-container:not(.button-container-theme-white):hover .icon-container {
        transform: translate(10%, -50%);
    }
    .button-container:not(.button-container-theme-white):hover .word {
        transform: translate(-1.5%, -51%);
    }
    .button-container-theme-white {
        color: #fff;
    }
    .button-container-theme-white .icon-container-bg {
        display: none;
    }
    .button-container-theme-white .icon-container {
        left: 8px;
        background-color: transparent;
    }
    .button-container-theme-white .word {
        right: 11px;
    }
    .button-container-theme-white:hover {
        color: #d2d2d2;
        border-color: #d2d2d2;
    }
    .button-container-theme-white:hover .icon-container .svg-icon {
        fill: #d2d2d2;
    }
    @keyframes ring-1199d941 {
        0% {
            transform: rotate(0);
        }
        15% {
            transform: rotate(25deg);
        }
        30% {
            transform: rotate(0);
        }
        45% {
            transform: rotate(25deg);
        }
        60% {
            transform: rotate(0);
        }
        to {
            transform: rotate(0);
        }
    }
    @keyframes signal-small-1199d941 {
        0% {
            opacity: 0;
        }
        60% {
            opacity: 0;
        }
        75% {
            opacity: 1;
        }
        90% {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    }
    @keyframes signal-big-1199d941 {
        0% {
            opacity: 0;
        }
        65% {
            opacity: 0;
        }
        80% {
            opacity: 1;
        }
        90% {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    }

    .klwk-nav {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
        width: 100%;
        height: 60px;
        color: #fff;
        transition: all 0.4s;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 1350px;
        box-shadow: 0px 4px 8px 0px rgba(220,220,220,0.4);
    }

    .klwk-nav .container .hoverLoginBtn {
        position: relative;
        width: 88px;
        height: 40px;
        margin-right: 14px;
    }

    .klwk-nav .container .hoverLoginBtn .experienceBtn,
    .klwk-nav .container .hoverLoginBtn .hoverBtn {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        transition: all 0.3s;
    }

    .klwk-nav .container .hoverLoginBtn .hoverBtn {
        opacity: 1;
    }

    .klwk-nav .container .hoverLoginBtn .experienceBtn {
        width: 88px;
        opacity: 0;
    }

    .klwk-nav .container .hoverLoginBtn:hover .hoverBtn {
        opacity: 0;
        transition: all 0.3s;
    }

    .klwk-nav .container .hoverLoginBtn:hover .experienceBtn {
        opacity: 1;
        transition: all 0.3s;
    }

    .klwk-nav .container .experienceBtn {
        width: 100px;
        height: 40px;
        position: relative;
        background-image: linear-gradient(0deg, #11ba1f, #12b661);
        border: none;
        color: #fff;
        cursor: pointer;
        outline: none;
        overflow: hidden;
        box-shadow: 0 14px 30px rgba(178, 100, 100, 0.15);
        font-size: 14px;
        font-weight: 500;
        border-radius: 2px;
        line-height: 40px;
        text-align: center;
    }

    .klwk-nav .container .experienceBtn span {
        position: relative;
        z-index: 99;
    }

    .klwk-nav .container .experienceBtn:before {
        --size: 20px;
        opacity: 0;
        content: "";
        position: absolute;
        left: var(--x);
        top: var(--y);
        width: var(--size);
        height: var(--size);
        background: radial-gradient(
                circle closest-side,
                rgba(0, 255, 248, 0.37647),
                transparent
        );
        transform: translate(-50%, -50%);
        transition: all 0.3s ease, left 0s, top 0s;
    }
    .klwk-nav .container .experienceBtn:hover:before {
        --size: 150px;
        opacity: 1;
    }
    .klwk-nav.white,
    .klwk-nav:hover {
        background: #fff !important;
        /* opacity: 0.9; */
    }
    .klwk-nav:hover a {
        color: #333 !important;
        font-weight: normal;
    }
    .klwk-nav.white .login,
    .klwk-nav:hover .login {
        color: #43b149 !important;
    }

    .klwk-nav .logo {
        margin-right: 50px;
        display: flex;
        align-items: center;
    }

    .klwk-nav .logo img {
        /* width: 40px; */
        /* height: 40px; */
        /* margin-right: -3px; */
    }

    .klwk-nav .logo i {
        font-size: 30px;
    }

    .klwk-nav .left {
        display: flex;
        align-items: center;
    }

    .klwk-nav .right {
        display: flex;
    }

    .klwk-nav .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        width: 1200px;
        margin: 0;
    }

    .klwk-nav .nav-list {
        display: flex;
    }

    .klwk-nav .phone {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #1478FF;
        width: 142px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid #1478FF;
    }
    .klwk-nav .phone img {
        margin-right: 4px;
        border: 0;
        vertical-align:  middle;
    }

    .klwk-nav .exp {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #43b149;
        width: 124px;
        box-sizing: border-box;
        color: #fff;
    }

    .klwk-nav .exp.login {
        background: transparent;
        color: inherit;
        padding: 0;
    }
    .klwk-nav .nav-btn {
        background: transparent;
        line-height: 60px;
        height: 60px;
        margin-right: 20px;
        color: inherit;
        position: relative;
        cursor: pointer;
    }
    .klwk-nav .nav-btn:last-child{
        margin-right: 10px;
    }
    .klwk-nav a {
        display: flex;
        align-items: center;

        color: #333;
        font-size: 16px;
        /* color: #fff; */
    }
    .klwk-nav.black a {
        color: #000 !important;
    }
    .klwk-nav .nav-btn > a:before {
        position: absolute;
        bottom: 0;
        left: 50%;
        z-index: 99;
        transform: translateX(-50%);
        content: "";
        width: 0;
        height: 4px;
        background-color: #1478FF;
        border-radius: 2px 2px 0 0;
        transition: width 0.3s;
    }
    .klwk-nav .nav-btn:hover > a {
        color: #333 !important;
        position: relative;
    }
    .klwk-nav .nav-btn img {
        margin-left: 4px;
    }
    .klwk-nav .nav-btn:hover > a:before {
        width: 100%;
        transition: width 0.3s;
    }

    .nav-btn > a {
        display: flex !important;
    }

    .klwk-nav.blur a {
        color: #000 !important;
    }
    .arrowHover {
        height: 4px;
        width: 7px;
        margin-left: 4px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAECAYAAABCxiV9AAAAAXNSR0IArs4c6QAAAFBJREFUGFdjTE9PP/fv37/C2bNnH2SAgtTUVHtGRsYJjCkpKQ5MTEwr////HwZSAJVYBeIzghTDFDAyMnb///+/FKYQLImkYOH////jYFYAAAusK3TfNYqmAAAAAElFTkSuQmCC) 50% no-repeat;
    }
    .nav-btn:hover .arrowHover {
        transform: rotate(180deg);
    }
    /*

      .klwk-nav .nav-btn>a:hover {
        color: #43b149;
        font-weight: 700;
      }

      .klwk-nav .nav-btn:hover>a:before {
        content: " ";
        width: 12px;
        height: 3px;
        background: #43b149;
        position: absolute;
        bottom: 5px;
        left: 50%;
        margin-left: -6px;
      }

      .klwk-nav .nav-btn>a,
      .klwk-nav button a {
        cursor: pointer;
        color: inherit;
        width: 100%;
        height: 100%;
        display: block;
      } */

    .nav-open-tab {
        position: absolute;
        /* top: 60px; */
        left: -32%;
        width: 150px;
        height: 0;
        line-height: 1;
        overflow: hidden;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        /* margin-top: 2px; */
        display: flex;
        background: #fff;
        color: #fff !important;
        transition: height 0.4s;
    }

    .nav-open-tab .open-aside {
        width: 290px;
        height: 100%;
        box-sizing: border-box;
        padding-top: 40px;
        /* background: linear-gradient(180deg, hsla(0, 0%, 100%, 0.71), #f6faff); */
        display: flex;
        flex-direction: column;
    }

    .nav-open-tab .open-aside .aside-item {
        margin-bottom: 40px;
        padding: 0 40px;
    }

    .nav-open-tab .open-aside .aside-item:last-of-type {
        margin-bottom: 0;
    }

    .nav-open-tab .open-aside p {
        color: #919499;
        font-size: 16px;
        margin-bottom: 14px;
    }

    .nav-open-tab .open-aside span {
        font-size: 20px;
        color: #202124;
    }

    .nav-open-tab .open-aside .cousult-text {
        margin-top: auto;
        color: #43b149;
        text-align: center;
        cursor: pointer;
        height: 60px;
        line-height: 60px;
        margin-bottom: 0;
        border-top: 1px solid #eff4fb;
    }

    .nav-open-app:hover .open-app {
        height: 280px;
    }

    .nav-open-tab.open-app .open-list {
        flex: 1;
        padding: 30px;
        display: flex;
        flex-wrap: wrap;
    }

    .nav-open-tab.open-app .open-list .item {
        width: 270px;
        height: 100px;
        transition: all 0.3s;
        text-align: left;
        cursor: pointer;
        margin-right: 20px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        box-sizing: border-box;
        transition: all 0.4s;
    }

    .nav-open-tab.open-app .open-list .item:hover {
        font-weight: 700;
    }

    .nav-open-tab.open-app .open-list .item i {
        width: 36px;
        height: 36px;
        background-size: cover;
        margin-right: 10px;
    }

    .nav-open-tab.open-app .open-list .item p {
        font-size: 20px;
        color: #202124;
        margin-bottom: 10px;
    }

    .nav-open-tab.open-app .open-list .item span {
        color: #919499;
        font-size: 14px;
    }

    .nav-open-download:hover .open-download {
        height: 280px;
    }

    .nav-open-tab.open-download .open-list {
        flex: 1;
        display: flex;
    }

    .nav-open-tab.open-download .item {
        flex: 1;
        padding-left: 100px;
        height: 100%;
        padding-top: 40px;
        box-sizing: border-box;
        color: #202124;
        border-right: 1px solid #f5f6f7;
    }

    .nav-open-tab.open-download .item:last-of-type {
        border-right: none;
    }

    .nav-open-tab.open-download .item h2 {
        font-size: 20px;
        margin-bottom: 34px;
        font-weight: 700;
    }

    .nav-open-tab.open-download .item a {
        font-size: 16px;
        display: block;
        line-height: 1;
        margin-bottom: 34px;
        height: auto;
    }

    .nav-open-tab.open-download .item a:last-of-type {
        margin-bottom: 0;
    }

    .nav-open-tab.open-download .item a:hover {
        color: #43b149;
    }
    .nav-open-app ._open-app .open-app-box {
        width: 150px;
        margin: 0 auto;
        /* display: flex; */
    }

    .nav-open-app ._open-app .open-app-box .left {
        padding: 0 20px 0 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-right: 1px solid rgba(0, 108, 255, 0.1);
    }

    .nav-open-app ._open-app .open-app-box .left .mk-img {
        width: 604px;
    }

    .nav-open-app ._open-app .open-app-box .left .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #60646b;
        line-height: 14px;
        margin-bottom: 12px;
        padding-left: 18px;
    }

    .nav-open-app ._open-app .open-app-box .left .list {
        display: flex;
        flex-flow: wrap;
        min-width: 346px;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item {
        display: flex;
        align-items: center;
        /* height: 94px; */
        padding: 16px 14px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #202124;
        line-height: 16px;
        box-sizing: border-box;
        transition: background-color 0.2s;
        /* background-color: rgba(0, 108, 255, 0); */
        cursor: pointer;
        min-width: 298px;
        position: relative;
        overflow: hidden;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item .itemBg {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-size: 100% 100%;
        transform: scale(1.1);
        opacity: 0;
        transition: all 0.8s;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item > div {
        display: flex;
        align-items: flex-start;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item > div > img {
        width: 46px;
        height: 46px;
        margin-right: 12px;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item > div .noactive {
        display: block;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item > div .isactive {
        display: none;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item .arrow {
        width: 20px;
        height: 20px;
        opacity: 0;
        transition: all 0.2s;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item .b-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        margin-top: 4px;
        margin-bottom: 10px;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item .desc-title {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        width: 226px;
        color: #7a8799;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 22px;
        transition: all 0.3s;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item:hover {
        color: #43b149 !important;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item:hover .desc-title {
        color: #202124;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item:hover .itemBg {
        transform: scale(1);
        /* opacity: 1; */
        transition: all 0.8s;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item:hover .b-title {
        color: #43b149;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item:hover .noactive {
        display: block;
    }

    .nav-open-app ._open-app .open-app-box .left .list .item:hover .arrow {
        /* opacity: 1; */
    }

    .nav-open-app ._open-app .open-app-box .right {
        padding-top: 40px;
        padding-left: 32px;
        flex: 1;
        width: auto;
    }

    .nav-open-app ._open-app .open-app-box .right .item .list-item {
        display: flex;
        align-items: center;
        width: 260px;
        height: 80px;
        border-radius: 8px;
        padding-left: 17px;
        box-sizing: border-box;
        margin-bottom: 20px;
        cursor: pointer;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #202124;
        line-height: 16px;
        position: relative;
        overflow: hidden;
    }

    .nav-open-app ._open-app .open-app-box .right .item .list-item .oneLine {
        display: flex;
        align-items: center;
    }

    .nav-open-app ._open-app .open-app-box .right .item .list-item .oneLine > img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }

    .nav-open-app ._open-app .open-app-box .right .item .list-item p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #7a8799;
        line-height: 14px;
        padding-left: 32px;
        padding-top: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .nav-open-app ._open-app .open-app-box .right .item .list-item .itemBg {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        transform: scale(1.1);
        /* opacity: 0; */
        transition: all 0.8s;
    }

    .nav-open-app ._open-app .open-app-box .right .item .list-item .itemContent {
        position: absolute;
        z-index: 99;
    }

    .nav-open-app ._open-app .open-app-box .right .item .list-item .itemContent p {
        white-space: nowrap;
    }

    .nav-open-app ._open-app .open-app-box .right .item.first {
        width: 540px;
        flex-shrink: 0;
    }

    .nav-open-app ._open-app .open-app-box .right .item.first .list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .nav-open-app ._open-app .open-app-box .right .item.first .list .list-item {
        padding: 18px 16px;
        transition: background-color 0.2s;
        /* background-color: rgba(0, 108, 255, 0); */
        display: block;
        border-radius: 6px;
    }

    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.first
    .list
    .list-item:hover
    > i,
    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.first
    .list
    .list-item:hover {
        color: #43b149 !important;
    }

    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.first
    .list
    .list-item:hover
    .itemBg {
        transform: scale(1);
        /* opacity: 1; */
        transition: all 0.8s;
    }

    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.first
    .list
    .list-item:hover
    .itemContent
    p {
        color: #202124;
    }

    .nav-open-app ._open-app .open-app-box .right .item.second,
    .nav-open-app ._open-app .open-app-box .right .item.third {
        margin-left: 27px;
    }

    .nav-open-app ._open-app .open-app-box .right .item.second .list .list-item,
    .nav-open-app ._open-app .open-app-box .right .item.third .list .list-item {
        padding: 18px 16px;
        /* transition: background-color 0.2s; */
        /* background-color: rgba(0, 108, 255, 0); */
        display: block;
        border-radius: 6px;
    }

    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.second
    .list
    .list-item:hover
    > i,
    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.second
    .list
    .list-item:hover,
    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.third
    .list
    .list-item:hover
    > i,
    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.third
    .list
    .list-item:hover {
        color: #43b149 !important;
    }

    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.second
    .list
    .list-item:hover
    .itemBg,
    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.third
    .list
    .list-item:hover
    .itemBg {
        transform: scale(1);
        opacity: 1;
        transition: all 0.5s;
    }

    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.second
    .list
    .list-item:hover
    .itemContent
    p,
    .nav-open-app
    ._open-app
    .open-app-box
    .right
    .item.third
    .list
    .list-item:hover
    .itemContent
    p {
        color: #202124;
    }

    .nav-open-app ._open-app .open-app-box .right .title {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #202124;
        line-height: 16px;
        padding-bottom: 24px;
        border-bottom: 1px solid #edeff2;
        margin-bottom: 16px;
        margin-left: 13px;
    }

    .nav-open-app ._open-app .open-app-box .right .title > img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
    }

    .nav-open-app ._open-app .open-app-box .right .product-title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #7a8799;
        line-height: 20px;
        padding-left: 15px;
        margin-bottom: 12px;
    }

    .nav-open-app:hover ._open-app {
        height: auto;
        padding-bottom: 26px;
        /* 导航下展开 */
    }

    /* 鼠标经过 */
    .product-page .banner {
        height: 480px;
        text-align: center;
    }
    .product-page .banner .logo {
        margin-top: 60px;
        width: 120px;
        height: 120px;
    }
    .product-page .banner .text {
        width: 45%;
        margin: 0 auto;
        line-height: 36px;
        color: #fff;
        font-size: 18px;
    }
    .product-page .banner .email {
        display: inline-block;
        margin: 68px auto 0;
    }
    .product-page .slogan {
        margin: 68px auto 0;
        width: 1115px;
        height: 222px;
        overflow: hidden;
        text-align: center;
        box-shadow: 0 3px 8px 0 rgba(9, 10, 11, 0.08);
        background-image: url(/static/common/moka_element.svg);
        background-repeat: no-repeat;
        background-position: 90% bottom;
        background-size: 122px;
    }
    .product-page .slogan .title {
        margin-top: 52px;
        font-size: 32px;
        font-weight: 700;
        color: #0e1421;
    }
    .product-page .slogan .text {
        width: 604px;
        margin: 20px auto 0;
        line-height: 24px;
        color: #758296;
    }
    .product-page .mage {
        width: 1115px;
        height: 430px;
        overflow: hidden;
        margin: auto;
        padding: 10px 0;
    }
    .product-page .mage:not(:last-child) {
        border-bottom: 1px solid #dfe2eb;
    }
    .product-page .mage .title {
        margin-bottom: 24px;
        font-size: 32px;
        font-weight: 700;
        color: #0e1421;
    }
    .product-page .mage .text {
        font-size: 14px;
        line-height: 32px;
        color: #758296;
    }
    .product-page .mage .mage-left {
        float: left;
        overflow: hidden;
        width: 557px;
    }
    .product-page .mage .image {
        width: 557px;
    }
    .product-page .bottom-container {
        position: relative;
        padding-top: 328px;
    }
    .product-page .user {
        position: absolute;
        top: 60px;
        left: calc(50% - 505px);
        width: 1010px;
        height: 328px;
        z-index: 1;
        text-align: center;
        margin: 0 auto;
        padding: 0 140px;
        background: #fff;
        background-image: url(/static/common/quote.svg);
        background-repeat: no-repeat;
        background-position: 60px 60px;
        box-shadow: 0 0 21px 0 rgba(14, 20, 33, 0.05);
        border: 1px solid #f2f6ff;
        border-radius: 8px;
    }
    .product-page .user .logo {
        width: 200px;
        margin-top: 42px;
    }
    .product-page .user .text {
        margin-top: 30px;
        line-height: 36px;
        font-size: 14px;
        color: #494d5a;
    }
    .product-page .bottom {
        height: 288px;
        position: relative;
        overflow: hidden;
        background-image: linear-gradient(0deg, #2b60fa, #3784ff);
    }
    .product-page .bottom .body {
        margin: 120px auto 0;
        width: 1020px;
    }
    .product-page .bottom .title {
        font-size: 32px;
        color: #fff;
    }
    .product-page .bottom .email {
        float: right;
    }
    .product-page .bottom .image {
        position: absolute;
        bottom: 0;
        left: -90px;
        width: 452px;
        opacity: 0.06;
    }
    @media screen and (min-width: 310px) and (max-width: 768px) {
        .product-page .banner {
            height: 249px;
            text-align: center;
        }
        .product-page .banner .logo {
            margin-top: 30px;
            width: 58px;
            height: 32px;
        }
        .product-page .banner .text {
            width: 82%;
            margin: 13px auto 0;
            line-height: 20px;
            color: #fff;
            font-size: 12px;
        }
        .product-page .banner .email {
            display: inline-block;
            margin: 34px auto 0;
        }
        .product-page .slogan {
            margin: 46px auto 0;
            width: 312px;
            height: 232px;
            overflow: hidden;
            text-align: center;
            box-shadow: 0 3px 8px 0 rgba(9, 10, 11, 0.08);
            background-image: url(/static/common/moka_element.svg);
            background-repeat: no-repeat;
            background-position: 90% bottom;
            background-size: 122px;
        }
        .product-page .slogan .title {
            margin-top: 26px;
            font-size: 20px;
            font-weight: 700;
            color: #0e1421;
        }
        .product-page .slogan .text {
            width: 272px;
            margin: 16px auto 0;
            line-height: 20px;
            color: #758296;
        }
        .product-page .mage {
            width: 312px;
            height: 470px;
            overflow: hidden;
            margin: auto;
            padding: 32px 0 24px;
        }
        .product-page .mage:not(:last-child) {
            border-bottom: 1px solid #dfe2eb;
        }
        .product-page .mage .title {
            margin-bottom: 16px;
            font-size: 20px;
            font-weight: 700;
            color: #0e1421;
        }
        .product-page .mage .text {
            font-size: 12px;
            line-height: 20px;
            color: #758296;
        }
        .product-page .mage .text span {
            display: block;
            margin-bottom: 8px;
        }
        .product-page .mage .mage-up {
            width: 312px;
        }
        .product-page .mage .mage-down {
            height: 208px;
        }
        .product-page .mage .image {
            width: 312px;
            height: 208px;
        }
        .product-page .mage-four {
            height: 500px;
        }
        .product-page .mage-one {
            height: 390px;
        }
        .product-page .bottom-container {
            position: relative;
            padding-top: 328px;
        }
        .product-page .user {
            position: absolute;
            top: 30px;
            left: calc(50% - 156px);
            width: 312px;
            height: 328px;
            z-index: 1;
            text-align: center;
            margin: 0 auto;
            padding: 0 20px;
            background: #fff;
            background-image: url(/static/common/quote.svg);
            background-repeat: no-repeat;
            background-position: 60px 60px;
            box-shadow: 0 0 21px 0 rgba(14, 20, 33, 0.05);
            border: 1px solid #f2f6ff;
            border-radius: 8px;
        }
        .product-page .user .logo {
            width: 160px;
            margin-top: 40px;
        }
        .product-page .user .text {
            margin-top: 5px;
            line-height: 20px;
            font-size: 12px;
        }
        .product-page .bottom {
            height: 200px;
            position: relative;
            overflow: hidden;
            background-image: linear-gradient(0deg, #2b60fa, #3784ff);
        }
        .product-page .bottom .body {
            margin: 54px auto 0;
            width: 360px;
        }
        .product-page .bottom .title {
            display: block;
            font-size: 22px;
            color: #fff;
            margin: 0 auto;
            text-align: center;
            font-weight: 500;
        }
        .product-page .bottom .email {
            clear: both;
            position: relative;
            left: -20px;
        }
        .product-page .bottom .image {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 327px;
            opacity: 0.06;
        }
    }
    .solution-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .cards {
        display: flex;
        flex-wrap: wrap;
        margin-top: 24px;
        margin-bottom: 24px;
        width: 1232px;
    }
    .card-item {
        position: relative;
        margin: 0 16px;
        width: 276px;
        height: 306px;
    }
    .card-item:hover {
        z-index: 1;
    }
    .card-item:hover .front {
        transform: scale(0.9);
        opacity: 0;
    }
    .card-item:hover .back,
    .front {
        opacity: 1;
        transform: scale(1);
    }
    .front {
        transition: all 0.5s ease;
    }
    .back,
    .front {
        height: 100%;
        width: 100%;
    }
    .back {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        transform: scale(0.8);
        transition: all 0.3s ease;
    }

    .programme-open-tab {
        position: fixed;
        top: 60px;
        left: 0;
        width: 100%;
        height: 0;
        line-height: 1;
        font-weight: 400;
        overflow: hidden;
        display: flex;
        color: #fff !important;
        transition: height 0.4s;
    }
    .programme-open-app-box {
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 40px;
        background: #fff;
    }
    .programme_con ul {
        display: flex;
        width: 100%;
        margin-top: 36px;
    }
    .programme_con ul li {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-items: center;
        width: 25%;
    }
    .programme_con ul li a {
        flex-direction: column;
    }
    .programme_con ul li a:hover p {
        color: #1478FF;
    }
    .programme_con ul li p {

        margin-top: 16px;
        font-size: 16px;
    }
    .programme_con ul li label {
        display: inline-block;
        cursor: pointer;
        width: 46px;
        height: 46px;
    }
    .programme_con ul li:nth-child(1) label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_wei_jishipeisong.png');
    }
    .programme_con ul li:nth-child(1):hover label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_xuan_jishipei.png');
    }
    .programme_con ul li:nth-child(2) label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_wei_hulian.png');
    }
    .programme_con ul li:nth-child(2):hover label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_xuan_wang.png');
    }
    .programme_con ul li:nth-child(3) label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_wei_qichezhi.png');
    }
    .programme_con ul li:nth-child(3):hover label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_xuan_qichezao.png');
    }
    .programme_con ul li:nth-child(4) label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_wei_tongxinying.png');
    }
    .programme_con ul li:nth-child(4):hover label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_xuan_tongxinying.png');
    }
    .programme_con ul li:nth-child(5) label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_wei_nengyuan.png');
    }
    .programme_con ul li:nth-child(5):hover label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_xuan_nengyuan.png');
    }
    .programme_con ul li:nth-child(6) label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_wei_jinrongxian.png');
    }
    .programme_con ul li:nth-child(6):hover label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_xuan_jinrongxian.png');
    }
    .programme_con ul li:nth-child(7) label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_wei_shipinkuai.png');
    }
    .programme_con ul li:nth-child(7):hover label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_xuan_shipinxiao.png');
    }
    .programme_con ul li:nth-child(8) label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_wei_zhengfuyangyi.png');
    }
    .programme_con ul li:nth-child(8):hover label{
        background: url('https://cdn.kuailework.com/images/website/images/index/icon_xuan_zhengfuyangqi.png');
    }
</style>

